import home from './home';
import org from './org';
import orgNew from './org-new';
import orgOld from './org-old';
import baseinfo from './baseinfo';
import materials from './materials';
import furniture from './furniture';
import ue from './ue';
import design from './design';
import designNew from './design-new';
import finance from './finance';
import brandStore from './brand-store';
import digitalAsset from './digital-asset';
import portal from './portal';
import data from './data';
import statistics from './statistics';
import profile from './profile';
import customerProject from './customer-project';

export default [
    ...home,
    ...org,
    ...orgNew,
    ...orgOld,
    ...baseinfo,
    ...materials,
    ...furniture,
    ...ue,
    ...design,
    ...designNew,
    ...customerProject,
    ...finance,
    ...brandStore,
    ...digitalAsset,
    ...portal,
    ...data,
    ...statistics,
    ...profile,
];
